import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getReferrals} from '../../../apis/cashback/getReferrals'

const useQueryReferrals = () => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.payback.getReferrals(),
        queryFn: async () => {
            const {data} = await getReferrals()
            return {data}
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryReferrals
